import React from 'react';
import MuiButton, {ButtonProps} from '@mui/material/Button';

export type P3Props = ButtonProps & {
  text: string;
  variant?: 'text' | 'outlined' | 'contained';
  size?: 'small' | 'medium' | 'large';
  textTransform?: 'none' | 'capitalize' | 'uppercase' | 'lowercase';
  onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined
  disabled?:boolean
}

export const Button = ({text, size, variant="outlined",textTransform = "none", onClick,disabled, ...props}: P3Props): JSX.Element => {
  return(
    <MuiButton size={size} onClick={onClick} variant={variant} disabled={disabled} style={{textTransform:textTransform}}  {...props}>{text}</MuiButton>
  )
}
